import SpellingError from './SpellingError'
export default SpellingError
